import { render, staticRenderFns } from "./DragImage.vue?vue&type=template&id=d63bd514&scoped=true&"
import script from "./DragImage.vue?vue&type=script&lang=js&"
export * from "./DragImage.vue?vue&type=script&lang=js&"
import style0 from "./DragImage.vue?vue&type=style&index=0&id=d63bd514&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63bd514",
  null
  
)

export default component.exports